import React from "react";
import Navbar from "./Navbar";
import { useTranslation } from "react-i18next";


const Instruccions = () => {
  const { t } = useTranslation();


  return (
    <div className="make-test">
      <Navbar />

      <div className="container">
        <div className="row p-5 text-center">
          <div className="col">
            <img
                src={"Logo_thc.jpeg"}
                className="rounded card-img-top w-25"
                alt="..."
            ></img>
            <h2 className="text-light mt-3">{t('instructions')}</h2>
          </div>
        </div>
        <div className="row">
          <div className="col">

            <p className="text-light">
              {t('step1')}
            </p>
            <p className="text-light">
              {t('step2')}
            </p>
            <p className="text-light">
              {t('step3')}
            </p>
            <p className="text-light">
              {t('step4')}
            </p>
            <p className="text-light">
              {t('step5')}
            </p>

            <p className="text-light">
              {t('step6')}
            </p>

            <p className="text-light">
              {t('step7')}
            </p>

            <p className="text-light">
              {t('step8')}
            </p>

            <p className="text-light">
              {t('step9')}
            </p>
          </div>

          {/* <div className="row m-1">
            <div className="col">
              <p className="text-light">{t('description1')}</p>
              <p className="text-light">{t('description2')}</p>
              <p className="text-light">{t('description3')}</p>
              <p className="text-light">{t('description4')}</p>
              <p className="text-light">{t('description5')}</p>
              <p className="text-light">{t('description6')}</p>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );

}

export default Instruccions
